






















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseInputFile from "@/components/BaseInputFile";
import BaseMenu from "@/components/BaseMenu";

export default defineComponent({
  name: "ImageUpload",
  components: { BaseMenu, BaseInputFile },
  props: {
    fullWidth: { type: Boolean },
    fullHeight: { type: Boolean },
    deleteText: { type: String as PropType<TranslateResult | string>, default: $t("Delete") },
  },
  setup(props) {
    const menuItems = computed<BaseMenuItem[]>(() => [
      { name: "new", text: $t("Upload new") },
      { name: "delete", text: props.deleteText, class: "negative" },
    ]);

    return { menuItems };
  },
});
